import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClientHelperService } from "./http-client-helper.service";
import { AssessmentHistoryVersion, AssessmentResourceId } from "./models/assessments/assessment.interface";
import { AssessmentPage } from "../ai-assessments/models/assessments.interface";

@Injectable({
  	providedIn: 'root'
})
export class ApiClientAssessmentVersioningService {
	private readonly controller = 'assessment/v4';

    constructor(
        private httpClientHelper: HttpClientHelperService
    ) { }

	getAssessmentVersionHistory(assessmentPageId: AssessmentResourceId): Observable<AssessmentHistoryVersion[]> {
		return this.httpClientHelper
			.invokeGetAuth<AssessmentHistoryVersion[]>(`${this.controller}/assessment-page/${assessmentPageId}/history`);
	}

	getAssessmentVersionById(assessmentPageId: AssessmentResourceId, versionId: string): Observable<AssessmentPage> {
		return this.httpClientHelper
			.invokeGetAuth<AssessmentPage>(`${this.controller}/assessment-page/${assessmentPageId}/history/${versionId}`);
	}

	restoreAssessmentVersion(assessmentPageId: AssessmentResourceId, versionId: string): Observable<AssessmentPage> {
		return this.httpClientHelper
			.invokePutAuth<AssessmentPage>(`${this.controller}/assessment-page/${assessmentPageId}/restore/${versionId}`);
	}
}